import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-child-curriculum-dashboard',
  templateUrl: './child-curriculum-dashboard.component.html',
  styleUrls: ['./child-curriculum-dashboard.component.scss']
})
export class ChildCurriculumDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
